/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  CalculateResultForOperator,
  CalculateResultForOperatorFromJSON,
  CalculateResultForOperatorFromJSONTyped,
  CalculateResultForOperatorToJSON,
} from "./";

/**
 *
 * @export
 * @interface CalculateResultItem
 */
export interface CalculateResultItem {
  /**
   *
   * @type {string}
   * @memberof CalculateResultItem
   */
  targetGroupName: string;
  /**
   *
   * @type {Array<CalculateResultForOperator>}
   * @memberof CalculateResultItem
   */
  results: Array<CalculateResultForOperator>;
}

export function CalculateResultItemFromJSON(json: any): CalculateResultItem {
  return CalculateResultItemFromJSONTyped(json, false);
}

export function CalculateResultItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CalculateResultItem {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    targetGroupName: json["targetGroupName"],
    results: (json["results"] as Array<any>).map(
      CalculateResultForOperatorFromJSON,
    ),
  };
}

export function CalculateResultItemToJSON(
  value?: CalculateResultItem | null,
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    targetGroupName: value.targetGroupName,
    results: (value.results as Array<any>).map(
      CalculateResultForOperatorToJSON,
    ),
  };
}
